export default {
    authNotificationsTotal_zero: 'Você não possui notificações não lidas',
    serviceChat: {
        alert_title_closed: 'Chat Encerrado',
        alert_text_closed: 'Esse chat não está mais disponível',
        alert_text_closed_by: 'O chat foi encerrado por {{name}}',
        alert_title_chat_unavailable: 'Chat Indisponível',
        alert_text_chat_unavailable: 'O chat está sendo atendido por outro usuário',

        request: 'O cliente <b>{{name}}</b> está aguardando para ser atendido no <b>Chat</b>',
        request_customer: 'Você solicitou um atendimento via <b>Chat</b>',
        closed: 'O seu <b>Chat</b> foi encerrado por <b>{{name}}</b>',
        closed_user_agent: 'Você encerrou o seu <b>Chat</b> com o cliente <b>{{name}}</b>',
        closed_user_customer: 'Você encerrou o seu <b>Chat</b> com o atendente <b>{{name}}</b>',
        canceled_transfer_title: 'Cancelada Transferência',
        canceled_transfer_text: 'O usuário cancelou a transferência de chat',
        refused_transfer_title: 'Transferência Recusada',
        refused_transfer_text: 'O usuário recusou a transferência de chat',
    },
    call: {
        created: '<b>Novo Chamado</b> #{{number}} - <b>{{group}}</b> {{- category}} - {{subject}}',
        edited: 'Chamado #{{number}} <b>Editado</b> - <b>{{group}}</b> {{- category}} - {{subject}}',
        archived: 'Chamado <b>Arquivado</b> #{{number}} - <b>{{group}}</b> {{- category}} - {{subject}}',
        sla_limit_exceeded: 'Chamado #{{number}} - <b>{{group}}</b> {{- category}} - <b>Aviso de SLA ({{percentage}}%)</b>',
        transferred: 'Você recebeu <b>{{qnt}}</b> chamado(s) - <b>{{group}}</b> - Transferido do usuário {{from}}',
    },
    attendance: {
        created: 'O chamado #{{number}} foi <b>respondido</b> - <b>{{group}}</b> {{- category}} - {{subject}}',
    },
    task: {
        created: '<b>Nova Tarefa</b> #{{number}} - <b>{{group}}</b> - {{subject}}',
        edited: 'Tarefa #{{number}} <b>Editada</b> - <b>{{group}}</b> - {{subject}}',
        archived: 'Tarefa <b>Arquivada</b> #{{number}} - <b>{{group}}</b> - {{subject}}',
    },
}
